import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'RequestRecaptcha/REQUEST_RECAPTCHA_ERROR',
    PENDING: 'RequestRecaptcha/REQUEST_RECAPTCHA_PENDING',
    SUCCESS: 'RequestRecaptcha/REQUEST_RECAPTCHA_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
